module.exports = {
	"app": ".Z1Popgs/src/pages/_app.scss-app"
};